// @flow
import * as React from 'react';
import classNames from 'classnames/bind';
import cs from './styles.pcss';
import t from './locale';
import { HeaderRow, Cell } from '../../../basic-components/table';
import { flex } from '../../stock-table/flexconfig';
import PublishSwitcher from '../ai-modal-publish-switcher';
import type { StockData_showcases as ShowcaseT } from '../../../typings/product-query.flow';
import Checkbox from '../../../basic-components/checkbox';

const cx = classNames.bind(cs);

type Props = {
  showcases: ShowcaseT[],
  selectedCount: number,
  checkedProducts: string[],
  checkedVariations: Set<string>,
  onToggleAll: () => void,
  checkedAll: boolean,
};

export default function AiMassEditRow({
  showcases,
  selectedCount,
  checkedProducts = [],
  checkedVariations = new Set(),
  onToggleAll,
  checkedAll,
}: Props): React.Node {
  const totalChecked = selectedCount;

  return (
    <HeaderRow largePadding sticky className={cx('massEdit')}>
      <Cell
        className={cx('title', { inactive: !totalChecked })}
        {...flex('title')}
      >
        <Checkbox
          onChange={onToggleAll}
          checked={checkedAll}
          className={cx('checkbox')}
        />
        {totalChecked ? (
          <div className={cx('actions')}>
            <span className={cx('selected-text')}>
              {t('selectedItems', { count: totalChecked })}
            </span>
          </div>
        ) : (
          <div className={cx('inactive')}>{t('tip')}</div>
        )}
      </Cell>
      {totalChecked ? (
        <>
          <Cell {...flex('sku')} />
          <Cell {...flex('amount')} />
          {showcases.map(({ id: sId }) => (
            <Cell key={sId} {...flex('listing')}>
              <PublishSwitcher
                showcaseId={sId}
                productId="mass"
                published={false}
                selected="unclear"
                hover
                synchronizable
                managed
                checkedProducts={checkedProducts}
                checkedVariations={checkedVariations}
              />
            </Cell>
          ))}
        </>
      ) : null}
    </HeaderRow>
  );
}
